import { useCallback, useContext } from 'react';
import { ChatContextType } from '@trinity/chat';
import { ChatPageContextDataContext } from '@trinity/chat-components/components/Chat/context.js';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context.js';
import { resetContextSubject } from '@trinity/chat-components/components/Chat.State/state.chat-session.js';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier.js';

/**
 * Returns a callback that starts a new chat session using the current
 * agent page-context, or `null` when no page-context is available.
 *
 * Must be called inside `ChatContextProviders` (or equivalent).
 */
export function useCreateChatFromAgentContext(): (() => void) | null {
  const dispatch = useContext(ChatStateDispatchContext);
  const pageContext = useContext(ChatPageContextDataContext);
  const brandIdentifier = useActiveBrandIdentifier();

  const createChat = useCallback(() => {
    if (!pageContext || !brandIdentifier) return;

    const resetLandingCards =
      pageContext.type === ChatContextType.Agent && pageContext.data.showLandingCardsOnNewChat;

    dispatch({
      type: 'new-chat-started',
      payload: {
        context: resetContextSubject(pageContext, resetLandingCards),
        brandIdentifier,
        resetLandingCards,
      },
    });
  }, [dispatch, pageContext, brandIdentifier]);

  return pageContext && brandIdentifier ? createChat : null;
}
